<template>
  <v-row no-gutters>
    <v-col v-for="(header, index) in headers" v-if="header.canShow" :key="`table_header_${index}`" class="d-flex font-weight-bold align-center justify-start" :cols="header.cols">
      <v-col v-if="!header.isDivider" cols="5">
        <div class="py-4">
          <v-row no-gutters>
            <v-col cols="2">
              <v-icon>{{ header.icon }}</v-icon>
            </v-col>
            <v-col cols="10" align-self="center" class="justify-start">
              <span>{{ header.label }}</span>
              <span v-if="header.showCounter"> ({{ header.counter || 0 }})</span>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col v-if="isCustomerHeader(header)" cols="2">
        <span>Age</span>
      </v-col>
      <v-col v-if="isHorseHeader(header)" cols="2">
        <div class="heavy-pink-bg">
          J
        </div>
      </v-col>
    </v-col>
    <v-col cols="12">
      <v-divider />
    </v-col>
  </v-row>
</template>

<script>

export default {
  props: {
    headers: {
      type: Array,
      default: null
    }
  },
  setup () {
    const isHorseHeader = header => header.key && header.key === 'horse';
    const isCustomerHeader = header => header.key && header.key === 'participant';

    return { isHorseHeader, isCustomerHeader };
  }
};
</script>
